import { getCssVar } from "../../types/theme.ts";

export const GreenCheck = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20.1875C11.3132 20.1875 12.6136 19.9288 13.8268 19.4263C15.0401 18.9237 16.1425 18.1872 17.0711 17.2586C17.9997 16.33 18.7362 15.2276 19.2388 14.0143C19.7413 12.8011 20 11.5007 20 10.1875C20 8.87428 19.7413 7.57392 19.2388 6.36067C18.7362 5.14741 17.9997 4.04502 17.0711 3.11643C16.1425 2.18785 15.0401 1.45125 13.8268 0.948705C12.6136 0.446158 11.3132 0.1875 10 0.1875C7.34784 0.1875 4.8043 1.24107 2.92893 3.11643C1.05357 4.9918 0 7.53534 0 10.1875C0 12.8397 1.05357 15.3832 2.92893 17.2586C4.8043 19.1339 7.34784 20.1875 10 20.1875ZM9.74222 14.2319L15.2978 7.56528L13.5911 6.14306L8.81333 11.8753L6.34111 9.40195L4.77 10.9731L8.10333 14.3064L8.96333 15.1664L9.74222 14.2319Z"
      fill={getCssVar("color_checkmark_icon")}
    />
  </svg>
);
